//import { buildQueries } from "@testing-library/react";
import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container, TextStyle, Text, Graphics, DEG_TO_RAD, Sprite, RenderTexture } from "pixi.js";
import tools from "tools";
import BoosterMenu from "../boosters/boosterMenu";
import boosterPopin from "../boosters/boosterPopin";
import BoosterRvPopin from "../boosters/boosterRvPopin";
import Flame from "../boosters/flame";
import HomeMenu from "../home/homeMenu";
import playerBubble from "../players/playerBubble";
import Skin from "../skin";
import Header from "./header";
import Parametres from "./parametres";
import Popin from "./popin";
import Stars from "./stars";
import Objectif from "./objectif";
import DefaultObjectif from "./defaultObjectif";
import Btn from "./btn";
const VIEW_WIDTH = config.view.x;
const VIEW_HEIGHT = config.view.y;
const _event = {
  "stopped": false,
  "stopsPropagatingAt": null,
  "stopPropagationHint": false,
  "target": null,
  "currentTarget": null,
  "type": "mousemove",
  "data": {
    "pressure": 0,
    "rotationAngle": false,
    "twist": 0,
    "tangentialPressure": 0,
    "global": {
      "x": 1243,
      "y": 505
    },
    "target": null,
    "originalEvent": {
      "isTrusted": true
    },
    "identifier": 1,
    "isPrimary": true,
    "button": -1,
    "buttons": 0,
    "width": 1,
    "height": 1,
    "tiltX": 0,
    "tiltY": 0,
    "pointerType": "mouse"
  }
};
export default class Ui extends Container {
  constructor(layer, callback) {
    super();
    tools.autobind(this);
    this._movesVal = config.startMoves;
    this._score = 0;
    this._layer = layer;
    this._callback = callback;
    this.maxScore = 9999999;
    this.allGoalsBirds = [];
  }
  init() {
    const PopTitleStyle = new TextStyle({
      fontFamily: "Anja Eliane accent",
      fontSize: 54,
      fill: "#b5520c",
      //#0b2944
      align: "center",
      // --- Drop Shadow Settings ---
      dropShadow: true,
      dropShadowColor: "#333333",
      // Color of the shadow (usually black)
      dropShadowBlur: 1,
      // Softness of the shadow
      dropShadowAngle: Math.PI / 6,
      // Direction (in radians, e.g., 30 degrees)
      dropShadowDistance: 1,
      // How far the shadow sits from the text
      dropShadowAlpha: 0.3 // Opacity of the shadow
    });
    const TITLE = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 54,
      fill: '#ffffff',
      //#0b2944
      stroke: '#d9600a',
      strokeThickness: 1,
      align: "center",
      // --- Drop Shadow Settings ---
      dropShadow: true,
      dropShadowColor: '#d9600a',
      // Color of the shadow (usually black)
      dropShadowBlur: 1,
      // Softness of the shadow
      dropShadowAngle: Math.PI / 6,
      // Direction (in radians, e.g., 30 degrees)
      dropShadowDistance: 1,
      // How far the shadow sits from the text
      dropShadowAlpha: 0.5 // Opacity of the shadow
    });
    this.scale.y = 1;
    this.scale.x = 1;
    this.x = 0;
    this.y = 0;

    //new header deco : portrait
    this.headerSprite = new Sprite(assets.textures.headerP.texture);
    this.headerSprite.anchor.set(0.5);
    this.addChild(this.headerSprite);

    //new header deco : landscape
    this.headerSpriteL = new Sprite(assets.textures.headerL.texture);
    this.headerSpriteL.anchor.set(0.5);
    this.addChild(this.headerSpriteL);
    this.goalsL = new Sprite(assets.textures.goalsL.texture);
    this.goalsL.anchor.set(0.5);
    this.addChild(this.goalsL);
    const styleFarmLand = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 48,
      fill: '#fafad2',
      stroke: "0x000000",
      strokeThickness: 2,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 2,
      dropShadowColor: '0x000000',
      dropShadowDistance: 0
    });
    this.title = new Text('', styleFarmLand);
    this.title.anchor.set(.5, 0.5);
    this.addChild(this.title);
    const SubstyleFarmLand = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 48,
      fill: '#fafad2',
      stroke: "0x000000",
      strokeThickness: 2,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 2,
      dropShadowColor: '0x666666',
      dropShadowDistance: 0
    });
    this.subTitle = new Text('', SubstyleFarmLand);
    this.subTitle.anchor.set(.5, 0.5);
    this.addChild(this.subTitle);
    this._playerBubble = new playerBubble();
    this._playerBubble.x = config.view.x * .5;
    this._playerBubble.y = config.view.y * .35;
    this.addChild(this._playerBubble);
    const style = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 36,
      fill: '#fafad2'
    });
    this.movesTextTitle = new Text(assets.local.moves.toUpperCase(), PopTitleStyle);
    this.movesTextTitle.anchor.set(0.5, 0.5);
    this.addChild(this.movesTextTitle);
    this.HSText = new Text(assets.local.HiGHSCORE.toUpperCase(), PopTitleStyle);
    this.HSText.anchor.set(0.5, 0.5);
    this.addChild(this.HSText);
    this.moves = new Text(this._movesVal, style);
    this.moves.anchor.set(.5, 0.5);
    this.addChild(this.moves);
    this.movesMask = new Graphics();
    this.moves.mask = this.movesMask;
    this.addChild(this.movesMask);
    const counterStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 10,
      fill: '#2c9a4b'
    });
    this.greenb = new Sprite(assets.textures.bg.texture);
    this.greenb.anchor.set(0.5, 0.5);
    this.addChild(this.greenb);
    this.redb = new Sprite(assets.textures.br.texture);
    this.redb.anchor.set(0.5, 0.5);
    this.addChild(this.redb);
    this.blueb = new Sprite(assets.textures.bb.texture);
    this.blueb.anchor.set(0.5, 0.5);
    this.addChild(this.blueb);
    this.violetb = new Sprite(assets.textures.bv.texture);
    this.violetb.anchor.set(0.5, 0.5);
    this.addChild(this.violetb);
    this.orangeb = new Sprite(assets.textures.bo.texture);
    this.orangeb.anchor.set(0.5, 0.5);
    this.addChild(this.orangeb);
    this.multib = new Sprite(assets.textures.bm.texture);
    this.multib.anchor.set(0.5, 0.5);
    this.addChild(this.multib);
    this.greenT = new Text("0/0", counterStyle);
    this.greenT.anchor.set(.5, 0.5);
    this.addChild(this.greenT);
    this.blueT = new Text("0/0", counterStyle);
    this.blueT.anchor.set(.5, 0.5);
    this.addChild(this.blueT);
    this.orangeT = new Text("0/0", counterStyle);
    this.orangeT.anchor.set(.5, 0.5);
    this.addChild(this.orangeT);
    this.redT = new Text("0/0", counterStyle);
    this.redT.anchor.set(.5, 0.5);
    this.addChild(this.redT);
    this.violetT = new Text("0/0", counterStyle);
    this.violetT.anchor.set(.5, 0.5);
    this.addChild(this.violetT);
    this.multiT = new Text("0/0", counterStyle);
    this.multiT.anchor.set(.5, 0.5);
    this.addChild(this.multiT);
    this.GoalsTitle = new Text(assets.local.GOALS.toUpperCase(), TITLE);
    this.GoalsTitle.anchor.set(0.5, 0.5);
    this.addChild(this.GoalsTitle);
    const textStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 60,
      fill: '#2c5f9a'
    });
    let texte = new Text("ee", textStyle);
    let renderTexture = new RenderTexture.create({
      width: texte.width,
      height: texte.height
    });
    config.renderer.render(texte, {
      renderTexture
    });
    texte.destroy(true);
    const textScoreLabelStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 20,
      fill: '#ffffff'
    });
    let texteScoreLabel = new Text("ee", textScoreLabelStyle);
    renderTexture = new RenderTexture.create({
      width: texteScoreLabel.width,
      height: texteScoreLabel.height
    });
    config.renderer.render(texteScoreLabel, {
      renderTexture
    });
    texteScoreLabel.destroy(true);
    this.scoreLabel = new Sprite(renderTexture);
    this.scoreLabel.y = 20;
    this.scoreLabel.x = 6;
    // this.addChild(this.scoreLabel);

    let _size = 80;
    if (window.innerHeight > window.innerWidth) {
      _size = 50;
    }
    const emotionTextStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: _size,
      fill: config.ementionTextColor,
      stroke: "0x000000",
      strokeThickness: 3,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 4,
      dropShadowColor: '0xffffff',
      dropShadowDistance: 8
    });
    this.emotionText = new Text("", emotionTextStyle);
    this.emotionText.anchor.set(.5);
    this.emotionText.visible = false;
    this.addChild(this.emotionText);
    const scoreStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 28,
      fill: '#ffffff' //fill: ['#ffffff', '#ffca44'],
    });
    this._score = 0;
    this.scoreText = new Text(this._score, scoreStyle);
    this.scoreText.anchor.set(.5);
    this.addChild(this.scoreText);
    const multiplyerTextStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 80,
      fill: ['#ffffff', '#f4f4f4'],
      stroke: '#092376',
      strokeThickness: 10
    });
    this.multiplyerText = new Text("+" + config.scoreMultiplier, multiplyerTextStyle);
    this.multiplyerText.anchor.set(.5);
    this.multiplyerText.visible = false;
    this.addChild(this.multiplyerText);
    this.multiplyerText1 = new Text("+" + config.scoreMultiplier, multiplyerTextStyle);
    this.multiplyerText1.anchor.set(.5);
    this.multiplyerText1.visible = false;
    this.addChild(this.multiplyerText1);
    this.multiplyerText2 = new Text("+" + config.scoreMultiplier, multiplyerTextStyle);
    this.multiplyerText2.anchor.set(.5);
    this.multiplyerText2.visible = false;
    this.addChild(this.multiplyerText2);
    this.multiplyerText3 = new Text("+" + config.scoreMultiplier, multiplyerTextStyle);
    this.multiplyerText3.anchor.set(.5);
    this.multiplyerText3.visible = false;
    this.addChild(this.multiplyerText3);
    config.popin = this.popin = new Popin(this.layer, this.popinActive, this.popinHide);
    this.popin.x = VIEW_WIDTH >> 1;
    this.popin.y = VIEW_HEIGHT >> 1;
    this.addChild(this.popin);
    config.parametre = this.parametre = new Parametres(this.layer, this.popinActive, this.popinHide);
    this.parametre.x = VIEW_WIDTH >> 1;
    this.parametre.y = VIEW_HEIGHT >> 1;
    //this.addChild(this.parametre);

    this.stars = new Stars(10, {
      x: 0,
      y: 0,
      w: 150,
      h: 40
    });
    this.stars.x = 90;
    this.stars.y = 33;
    //this.stars.show();
    // this.stars.loop = true;
    // this.stars.debug = true;
    this.stars.scaleMax = .4;
    this.addChild(this.stars);
    this._emtionStars = new Stars(20, {
      x: 0,
      y: 0,
      w: 400,
      h: 70
    });
    // this._emtionStars.show();
    // this._emtionStars.loop = true;
    // this._emtionStars.debug = true;
    this._emtionStars.scaleMax = .6;
    this.emotionText.addChild(this._emtionStars);
    config.header = new Header();
    this.addChild(config.header);

    // Booster Manager

    config.boosterMenu = this.boosterMenu = new BoosterMenu();
    config.boosterMenu.visible = false;
    config.boosterPopin = this.boosterPopin = new boosterPopin();
    config.boosterRvPopin = new BoosterRvPopin();
    config.boosterRvPopin.x = config.view.x >> 1;
    config.boosterRvPopin.y = config.view.y >> 1;

    // Bomb booster init
    config.bomb = assets.textures.bombBoost;
    config.flame = new Flame();
    config.flame.scale.set(1.3);
    config.flame.play();

    //hammer init
    config.hammer = new Sprite(assets.textures.hammer.texture);
    config.hammer.visible = false;
    this.boosterMenu.bombCoinsVal = config.bombCoinsVal;
    this.boosterMenu.rocketCoinsVal = config.rocketCoinsVal;
    this.boosterMenu.swapCoinsVal = config.swapCoinsVal;
    this.boosterMenu.hammerCoinsVal = config.hammerCoinsVal;
    this.addChild(this.boosterMenu);
    this.pauseBt = new Btn("", 28, "#10b7fe", null, assets.textures.pauseBt.texture);
    this.pauseBt.scale.set(1.5);
    this.addChild(this.pauseBt);
    this.goalsL.anchor.set(0.5, 0.5);
  }
  featuresInit() {
    // Skin Page
    config.skinPop = this.skinPop = new Skin();
    this.skinPop.x = 5 + this.skinPop.size.width / 2;
    this.skinPop.y = 5 + this.skinPop.size.height / 2;

    // Home Menu
    config.homeMenu = this.homeMenu = new HomeMenu();
    this.homeMenu.y = 170;

    // Objectif
    this._objectif = new Objectif();
    config.objectif = this._objectif;
    this._objectif.x = 266;
    this._objectif.y = 234;

    // Default Objectif
    this._defaultObjectif = new DefaultObjectif();
    config.defaultObjectif = this._defaultObjectif;
    this._defaultObjectif.x = 266;
    this._defaultObjectif.y = 234;
  }
  setObjectifDatas() {
    // Sans leaderboard/bots, config.friends n'est plus rempli : on utilise l'objectif par défaut
    if (!config.friends) config.friends = [];
    let opponentExist = false;
    for (let i = 0; i < config.friends.length; i++) {
      if (config.friends[i].isOpponent) {
        opponentExist = true;
      }
    }
    if (config.reconnected || config.inviteFriend || config.currentContext || opponentExist) {
      config.UpdateCountData = {
        n: 0,
        data: []
      };
      this.removeChild(this._defaultObjectif);
      config.inviteFriend = false;
      this.getOpponent();
    } else {
      this.addDefaultObjectif();
    }

    //check background change
    const currentLevelData = this.getBG(config.playerLevel);
    if (!config.gameOver) {
      config.BG.texture = assets.textures[currentLevelData.obj.bg].texture;
    }
    config.BG.visible = true;
    this.title.text = assets.local[currentLevelData.obj.title];
    if (config.backgroundLevels[currentLevelData.index + 1]) this.subTitle.text = assets.local.NextWorld + " " + assets.local.LEVEL + " " + config.backgroundLevels[currentLevelData.index + 1].L;
  }
  getOpponent() {
    config.sdk.getProfileModule().getOpponent().then(value => {
      this.currentContext = 'default';
      // this.currentContext = Math.random() * 10000;

      if (value) {
        const opponent = value.length > 0 ? value[0] : value;

        // //debug
        // opponent.isOpponent = true;
        // opponent.isRealScore = true;
        // opponent.score = 3000;
        // //end debug

        if (opponent.isRealScore) {
          if (config.beatenOpponent.indexOf(this.currentContext) !== -1) {
            this.addDefaultObjectif();
            return;
          }
          config.objectif.reset();
          config.objectif.isKilled = false;
          config.objectif.score = opponent.score;
          config.objectif.isOpponent = opponent.isOpponent;
          config.objectif.text = "Beat your friend's score"; //assets.local.beatFriend;
          config.objectif.profilePic = opponent.imguri;
          config.objectif.profileName = opponent.name;
        } else {
          if (config.currentContext === this.currentContext) {
            this.addDefaultObjectif();
            return;
          }
          config.objectif.reset();
          config.objectif.score = "";
          config.objectif.text = "Make the highest score to challenge your friend"; //assets.local.doBestScore;
          config.objectif.profilePic = "default";
          config.objectif.profileName = "friend";
          config.objectif.isOpponent = false;
        }
        this.addChildAt(this._objectif, 1);
      } else {
        this.addDefaultObjectif();
      }
      config.currentContext = this.currentContext;
    });
  }
  addDefaultObjectif() {
    this.removeChild(this._objectif);
    config.defaultObjectif.text = "Goal"; //assets.local.beatObjectif;
    config.defaultObjectif.active = true;
    config.defaultObjectif.skinsUpdate();

    //  this.addChildAt(this._defaultObjectif, 1);
  }
  updateGoalTexts() {
    config.UpdateCount = false;
    //don't use execute for the first call
    if (config.UpdateCountData.n == 0) {
      config.UpdateCountData.n = 1;
      return;
    }
    //save data in the second call
    let _BallGoals;
    if (config.UpdateCountData.n == 1) {
      config.UpdateCountData.n++;
      config.UpdateCountData.data = config.defaultObjectif.BallGoals;
      _BallGoals = config.defaultObjectif.BallGoals;
    } else {
      _BallGoals = config.defaultObjectif.BallGoals;
    }
    if (!this.compareColors(_BallGoals, config.UpdateCountData.data)) {
      config.UpdateCountData.data = _BallGoals;
    }
    this.orangeT.text = "0/0";
    this.orangeT.visible = false;
    this.redT.text = "0/0";
    this.redT.visible = false;
    this.blueT.text = "0/0";
    this.blueT.visible = false;
    this.greenT.text = "0/0";
    this.greenT.visible = false;
    this.violetT.text = "0/0";
    this.violetT.visible = false;
    this.multiT.text = "0/0";
    this.multiT.visible = false;
    _BallGoals.forEach(bb => {
      if (bb.c == "0xf98c29") {
        this.generateValue(bb, this.orangeT);
        this.orangeT.visible = true;
      } else if (bb.c == "0xff001d") {
        this.generateValue(bb, this.redT);
        this.redT.visible = true;
      } else if (bb.c == "0x5282f6") {
        this.generateValue(bb, this.blueT);
        this.blueT.visible = true;
      } else if (bb.c == "0x4dba30") {
        this.generateValue(bb, this.greenT);
        this.greenT.visible = true;
      } else if (bb.c == "0x962beb") {
        this.generateValue(bb, this.violetT);
        this.violetT.visible = true;
      } else {
        this.generateValue(bb, this.multiT);
        this.multiT.visible = true;
      }
    });
    this.allGoalsBirds = [{
      t: this.greenT,
      b: this.greenb
    }, {
      t: this.orangeT,
      b: this.orangeb
    }, {
      t: this.redT,
      b: this.redb
    }, {
      t: this.violetT,
      b: this.violetb
    }, {
      t: this.blueT,
      b: this.blueb
    }, {
      t: this.multiT,
      b: this.multib
    }];
    this.reArrangeGoals();
  }
  generateValue(bb, forText) {
    let c = 0;
    const result = config.UpdateCountData.data.find(item => item.c === bb.c);
    if (result) {
      c = result.v - bb.v;
      forText.text = `${c}/ ${result.v}`;
      if (c >= result.v) {
        //to do :  animate the text
        forText.text = "✓";
      }
    }
  }
  setBtns(msg) {
    //hide skin button
    //this.addChild(this.homeMenu);

    this.addChild(this.skinPop);
    config.homeMenu.setBtns(msg);
    this.addChild(config.boosterPopin);
    // this.addChild(config.boosterRvPopin);
    this.addChild(this.popin);
    this.addChild(this.parametre);
    config.levelProgressionMode && this.setlevelProgressionUI();
  }
  getBG(currentLevel) {
    let bestIndex = 0;
    for (let i = 0; i < config.backgroundLevels.length; i++) {
      // If our current level is higher or equal to the requirement 'L'
      if (currentLevel >= config.backgroundLevels[i].L) {
        bestIndex = i;
      } else {
        // Since the array is sorted, we stop as soon as we hit a level too high
        break;
      }
    }
    return {
      obj: config.backgroundLevels[bestIndex],
      // The full {L, bg} object
      index: bestIndex // The position (0, 1, 2, etc.)
    };
  }
  updateLevel(level) {
    if (config.levelProgressionMode) {
      config.boosterMenu.update();
      config.skinPop.checkForUnlock();
      config.header.updateLevel(true);

      //initial background
      const currentLevelData = this.getBG(config.playerLevel);
      config.BG.texture = assets.textures[currentLevelData.obj.bg].texture;
      config.BG.visible = true;
      this.title.text = assets.local[currentLevelData.obj.title];
      if (config.backgroundLevels[currentLevelData.index + 1]) this.subTitle.text = assets.local.NextWorld + " " + assets.local.LEVEL + " " + config.backgroundLevels[currentLevelData.index + 1].L;
    }
  }
  setlevelProgressionUI() {
    config.boosterMenu.progressLevelMode = true;
    config.boosterMenu.update();
    config.header.updateLevel();
  }
  set movesText(val) {
    let oldVal = this._movesVal;
    this._movesVal = val;
    if (this._movesVal <= 0) {
      this.moves.text = 0;
    } else {
      if (oldVal >= this._movesVal) {
        this.moves.text = oldVal;
      }
      if (this.movesTextTween != null) {
        this.movesTextTween.resetTo("x", 1);
        this.movesTextTween.resetTo("y", 1);
        this.movesTextTween.kill();
      }
      if (this.movesTextTween2 != null) {
        this.movesTextTween2.kill();
      }
      this.movesTextTween = gsap.to(this.moves.scale, {
        duration: 0.2,
        x: 1.5,
        y: 1.5,
        ease: "none",
        onComplete: () => {
          this.moves.text = this._movesVal;
        }
      });
      this.movesTextTween2 = gsap.to(this.moves.scale, {
        duration: 0.2,
        delay: 0.2,
        x: 1,
        y: 1,
        ease: "none"
      });
    }
  }
  get movesText() {
    return this._movesVal;
  }
  set score(val) {
    this._score = val;
    this.scoreText.text = parseInt(this._score * config.scoreCoef > this.maxScore ? this.maxScore : this._score * config.scoreCoef);

    //!\\ ScoreStep Bonus
    if (this.scoreText.text >= config.header.bestScoreStep) {
      config.header.bestScoreStep += config.bestScoreStep;
      config.ui.bonusMoveVal = config.bonus1;
      config.ui.scoreBonus(100, 72, 1);
    }
  }
  get score() {
    return this._score;
  }
  set resultScore(value) {
    // Plus de leaderboard
  }
  get scoreTextObj() {
    return this.scoreText;
  }
  get emtionStars() {
    return this._emtionStars;
  }
  get layer() {
    return this._layer;
  }
  set bonusMoveVal(val) {
    this._bonusMoveVal = val;
  }
  get playerBubble() {
    return this._playerBubble;
  }
  showPopin() {
    this.popin.show();
  }
  parametreShow() {
    this.parametre.show();
    config.boosterRvPopin.hide();
  }
  popinActive() {
    this.boosterMenu.enable = false;
    this.homeMenu && (this.homeMenu.enable = false);
  }
  popinHide() {
    this.boosterMenu.enable = true;
    this.homeMenu && (this.homeMenu.enable = true);
  }
  saveScore(score) {
    let _score = parseInt(score * config.scoreCoef);
    if (parseInt(config.oldScore) <= 0 || !config.oldScore) {
      config.sdk.getScoreModule().getBestScore().then(data => {
        if (data !== null) {
          if (data > _score) {
            this.saveBestScore(data);
          } else {
            this.saveBestScore(_score);
          }
        } else {
          this.saveBestScore(0);
        }
      });
    } else {
      this.saveBestScore(_score);
    }
    if (_score > config.objectif.score && !config.objectif.isKilled) {
      if (config.beatenOpponent.indexOf(this.currentContext) == -1) {
        config.beatenOpponent += config.currentContext + ",";
      }
      config.objectif.kill(() => {
        config.level.updateCoins(config.bonusCoins2);
      }, () => {
        config.objectif.showInviteFriend();
      });
    }
  }
  saveBestScore(score) {
    if (score > config.oldScore) {
      if (!config.savedScoreAccess) {
        return;
      } // config.header.initOldScore(score);

      config.oldScore = score;
      config.sdk.getStoreModule().save("user", {
        score: score
      });
      //save score
      config.sdk.getScoreModule().setBestScore(parseInt(config.currentScore * config.scoreCoef));
    }
  }
  scoreBonus(x, y, textId = 0) {
    config.MovesIncProcess = true;
    let time = 0.25;
    let textObject;
    this.stars.show();
    switch (textId) {
      case 0:
        //connexion bonus text
        textObject = this.multiplyerText;
        break;
      case 1:
        //score 100K+ bonus text
        textObject = this.multiplyerText1;
        break;
      case 2:
        //beat some one bonus text
        textObject = this.multiplyerText2;
        break;
      case 3:
        //achieve default objectif 
        textObject = this.multiplyerText3;
        break;
      default:
        break;
    }
    textObject.visible = true;
    textObject.scale.set(0);
    textObject.text = "+" + this._bonusMoveVal;
    textObject.x = x;
    textObject.y = y;
    gsap.to(textObject.scale, {
      duration: time * .1,
      x: 1,
      y: 1,
      ease: "back.out(3)"
    });
    gsap.to(textObject, {
      duration: time * 1.5,
      delay: time * 1.5,
      x: this.moves.x,
      y: this.moves.y,
      onComplete: () => {
        gsap.to(textObject.scale, {
          duration: time * .3,
          x: 0,
          y: 0,
          onComplete: () => {
            textObject.visible = false;
            this.movesText += this._bonusMoveVal;
            if (this.movesText > config.startMoves) {
              this.movesText = config.startMoves;
            }
            config.MovesIncProcess = false;
            config.level.updateCoins(config.bonusCoins0);
          }
        });
      }
    });
  }
  showMotiontext(val, x, y, fromMissile, booster = false) {
    //config.Selected_Bubbles.rotation = Math.PI / 4;

    this.emotionText.y = window.innerHeight * 0.5;
    this.emotionText.scale.set(0);
    this.emotionText.alpha = 1;

    //!\\ limite bonus
    if (this.movesText < 20) {
      this._bonusMoveVal = config.bonus0;
    } else {
      this._bonusMoveVal = 0;
    }
    let text = "";
    if (val >= config.bonusScore) {
      config.scoreMultiplier = val - config.bonusScore + 2;
    } else {
      config.scoreMultiplier = 1;
    }
    switch (val) {
      case 6:
        text = assets.local.nice;
        break;
      case 7:
        text = assets.local.wow;
        this._bonusMoveVal = config.bonus1;
        config.ui.scoreBonus(100, 72, 1);
        break;
      case 8:
        text = assets.local.amazing;
        this._bonusMoveVal = config.bonus1;
        config.ui.scoreBonus(100, 72, 1);
        break;
      case 9:
        text = assets.local.superb;
        break;
      case -1:
        text = assets.local.GameOver;
        break;
      case -2:
        text = assets.local.NoMoreMove;
        break;
    }
    if (val > 9) {
      text = assets.local.perfect;
    }
    if (val >= config.bonusConnexion && !fromMissile) {
      this.scoreBonus(x, y, 0);
      this.movesText += this._bonusMoveVal;
    } else {
      config.hardLevelStep++;
      !booster && this.movesText--;
    }
    if (val == config.bonusBomb) {
      config.touchAccess = true;
      config.bombBoosterReady = true;
      setTimeout(() => {
        //config.bubbles[0][0].onDown(_event,true);
        config.Selected_Bubbles.onDown(_event, true);
      }, 1200);
    }
    if (val >= config.bonusScore || val == -1) {
      this._emtionStars.show();
      this.emotionText.text = text;
      this.emotionText.visible = true;
      gsap.to(this.emotionText.scale, {
        duration: .5,
        x: 1,
        y: 1,
        ease: "back.out(2)"
      });
      gsap.to(this.emotionText, {
        delay: .3,
        duration: .75,
        y: window.innerHeight * 0.5
      });
      gsap.to(this.emotionText.scale, {
        delay: 1,
        duration: .5,
        y: 0,
        x: 0
      });
      gsap.to(this.emotionText, {
        delay: 1,
        duration: .5,
        alpha: 0,
        onComplete: () => {
          this.emotionText.visible = false;
        }
      });
    }
  }
  start() {
    if (config.gameStarted || !config.touchAccess) {
      return;
    }
    config.sdk.getPlatform().notifyLevelStart(0);
    config.gameStarted = true;
    config.gameOver = false;
    this._callback && this._callback();
    let timer = setInterval(() => {
      if (this.homeMenu) {
        timer && clearInterval(timer);
        this.homeMenu.hide();
        config.objectif.show();
        config.defaultObjectif.show();
      }
    }, 60);
  }
  showHomeMenu() {
    config.gameStarted = false;
    config.objectif.hide();
    config.defaultObjectif.hide();
    this.homeMenu && this.homeMenu.show();
  }
  resetMoves(val, fromRV) {
    config.defaultObjectif.active = false;
    this._movesVal = val;
    this.moves.text = val;

    // if (fromRV) {
    //     gsap.to(this.movesPanel.scale, {
    //         duration: .2,
    //         x: .6,
    //         y: .6,
    //         ease: "none",
    //         onComplete: () => {
    //             gsap.to(this.movesPanel.scale, {
    //                 duration: .5,
    //                 x: .5,
    //                 y: .5,
    //                 ease: "back.out(3)"
    //             });
    //         }
    //     });
    // }
  }
  update(w, h) {
    this.skinPop && this.skinPop.update();
    if (config.UpdateCount) {
      this.updateGoalTexts();
    }
  }
  compareColors(arr1, arr2) {
    // 1. Check if they have the same number of elements
    if (arr1.length !== arr2.length) return false;

    // 2. Extract just the 'c' values into simple arrays
    const colors1 = arr1.map(item => item.c);
    const colors2 = arr2.map(item => item.c);

    // 3. Sort them (to handle cases where order is different) and compare
    colors1.sort();
    colors2.sort();
    return colors1.every((color, index) => color === colors2[index]);
  }
  reArrangeGoals() {
    let count = 0;
    if (window.innerHeight <= window.innerWidth) {
      let TY = this.goalsL.y - this.goalsL.height * 0.3;
      let TX = this.goalsL.x + this.goalsL.width * 0.2;
      let DY = this.goalsL.height * 0.12;
      let stratY = 0;
      if (config.UpdateCountData.data.length == 6) {
        stratY = TY;
      }
      if (config.UpdateCountData.data.length == 5) {
        stratY = TY + DY * 0.5;
      }
      if (config.UpdateCountData.data.length == 4) {
        stratY = TY + DY;
      }
      if (config.UpdateCountData.data.length == 3) {
        stratY = TY + DY * 1.5;
      }
      if (config.UpdateCountData.data.length == 2) {
        stratY = TY + DY * 2;
      }
      if (config.UpdateCountData.data.length == 1) {
        stratY = TY + DY * 2.5;
      }
      this.allGoalsBirds.forEach(obj => {
        if (obj.t.visible) {
          obj.b.visible = true;
          obj.t.position.set(TX, stratY + count * DY);
          if (obj.b.scale.x <= 0.1) {
            gsap.to(obj.b.scale, {
              duration: 1,
              x: window.innerWidth * 0.7 / 1920,
              y: window.innerWidth * 0.7 / 1920,
              ease: "bounce.out"
            });
            gsap.to(obj.t.scale, {
              duration: 1,
              x: 1,
              y: 1,
              ease: "bounce.out"
            });
          } else {
            obj.b.scale.set(window.innerWidth * 0.7 / 1920);
          }
          obj.b.position.set(obj.t.x - this.goalsL.width * 0.4, obj.t.y);
          count++;
        } else {
          obj.b.visible = false;
        }
      });
    } else {
      let TY = this.headerSprite.y + this.headerSprite.height * 0.055;
      let TX = this.headerSprite.x - this.headerSprite.width * 0.355;
      let DX = this.headerSprite.width * 0.14;
      let stratX = 0;
      if (config.UpdateCountData.data.length == 6) {
        stratX = TX;
      }
      if (config.UpdateCountData.data.length == 5) {
        stratX = TX + DX * 0.5;
      }
      if (config.UpdateCountData.data.length == 4) {
        stratX = TX + DX;
      }
      if (config.UpdateCountData.data.length == 3) {
        stratX = TX + DX * 1.5;
      }
      if (config.UpdateCountData.data.length == 2) {
        stratX = TX + DX * 2;
      }
      if (config.UpdateCountData.data.length == 1) {
        stratX = TX + DX * 2.5;
      }
      this.allGoalsBirds.forEach(obj => {
        if (obj.t.visible) {
          obj.b.visible = true;
          obj.t.position.set(stratX + count * DX, TY);
          if (obj.b.scale.x <= 0.1) {
            gsap.to(obj.b.scale, {
              duration: .5,
              x: window.innerWidth * 1 / 1920,
              y: window.innerWidth * 1 / 1920,
              ease: "bounce.out"
            });
            gsap.to(obj.t.scale, {
              duration: .5,
              x: 1,
              y: 1,
              ease: "bounce.out"
            });
          } else {
            obj.b.scale.set(window.innerWidth * 1 / 1920);
          }
          obj.b.position.set(stratX + count * DX, TY - this.headerSprite.height * 0.15);
          count++;
        } else {
          obj.b.visible = false;
        }
      });
    }
  }
  reseize() {
    this.scale.y = 1;
    this.scale.x = 1;
    this.x = 0;
    this.y = 0;
    //this.boosterMenu.updateView(window.innerHeight<=window.innerWidth);

    if (window.innerHeight > window.innerWidth) {
      this.headerSpriteL.visible = false;
      this.headerSprite.visible = true;
      this.goalsL.visible = false;
      let coefp = 355 / 880; // keep aspect ratio
      this.headerSprite.width = window.innerWidth * 0.8;
      this.headerSprite.height = window.innerWidth * 0.8 * coefp;
      this.headerSprite.position.set(window.innerWidth * 0.5, this.headerSprite.height * 0.51);
      config.header.reseize(this.headerSprite);
      this.moves.y = this.headerSprite.y + this.headerSprite.height * 0.36;
      this.moves.x = this.headerSprite.x + this.headerSprite.width * 0.33;
      this.movesTextTitle.x = this.moves.x;
      this.movesTextTitle.y = this.headerSprite.y + this.headerSprite.height * 0.2;
      this.movesTextTitle.style.fontSize = Math.round(window.innerWidth * 0.04);
      if (this.movesMask) {
        this.movesMask.clear();
      }
      this.movesMask.beginFill(0xff00000, 0.4); //0.4
      this.movesMask.drawRect(this.moves.x - 30, this.moves.y - this.moves.height * 0.51, 64, 40);
      this.movesMask.endFill();
      this.scoreText.y = this.headerSprite.y + this.headerSprite.height * 0.36;
      this.scoreText.x = this.headerSprite.x;
      this.HSText.x = this.scoreText.x;
      this.HSText.y = this.headerSprite.y + this.headerSprite.height * 0.2;
      this.HSText.style.fontSize = Math.round(window.innerWidth * 0.04);
      this.GoalsTitle.x = this.scoreText.x;
      this.GoalsTitle.y = this.headerSprite.y - this.headerSprite.height * 0.33;
      this.GoalsTitle.style.fontSize = Math.round(window.innerWidth * 0.05);
      this.moves.style.fontSize = Math.round(window.innerWidth * 0.05);
      this.scoreText.style.fontSize = Math.round(window.innerWidth * 0.05);
      this.boosterMenu.x = 0;
      this.boosterMenu.y = 0;
      this.greenT.style.fontSize = Math.round(window.innerWidth * 0.027);
      this.blueT.style.fontSize = Math.round(window.innerWidth * 0.027);
      this.orangeT.style.fontSize = Math.round(window.innerWidth * 0.027);
      this.redT.style.fontSize = Math.round(window.innerWidth * 0.027);
      this.violetT.style.fontSize = Math.round(window.innerWidth * 0.027);
      this.multiT.style.fontSize = Math.round(window.innerWidth * 0.027);
      this.title.style.fontSize = Math.round(window.innerWidth * 0.06);
      this.title.position.set(window.innerWidth * 0.5, this.headerSprite.y + this.headerSprite.height * 0.5 + this.title.height * 0.5);
      this.subTitle.style.fontSize = Math.round(window.innerWidth * 0.027);
      this.subTitle.position.set(window.innerWidth * 0.5, this.title.y + this.title.height * 0.5 + this.subTitle.height * 0.5);
      this.emotionText.position.set(window.innerWidth * 0.5, window.innerHeight * 0.5);
      this.boosterPopin.x = this.title.x;
      this.boosterPopin.y = this.headerSprite.y + this.headerSprite.height * 0.5 + this.boosterPopin.bg.height * 0.4;
      let coef = 375 / 0.15;
      this.pauseBt.scale.set(1.5 * window.innerWidth / coef);
      this.pauseBt.position.set(window.innerWidth - this.pauseBt.width * 1.1 * 0.5,
      // window.innerHeight - this.pauseBt.height*1.1*0.5
      config.boosterMenu.footerP.y);
    }
    //landscape
    else {
      this.headerSprite.visible = false;
      this.headerSpriteL.visible = true;
      this.goalsL.visible = true;
      let coefH = 134 / 747; // headerL
      let coefG = 871 / 276; //goals Landscape

      let scree_cof = window.innerWidth / window.innerHeight;
      if (scree_cof < 1.4) {
        //ipad
        this.headerSpriteL.width = window.innerWidth * 0.5;
        this.headerSpriteL.height = window.innerWidth * 0.5 * coefH;
        this.goalsL.height = window.innerHeight * 0.75;
        this.goalsL.width = this.goalsL.height / coefG;
      } else {
        //iphone
        this.headerSpriteL.width = window.innerWidth * 0.4;
        this.headerSpriteL.height = window.innerWidth * 0.4 * coefH;
        this.goalsL.height = window.innerHeight * 0.75;
        this.goalsL.width = this.goalsL.height / coefG;
      }
      this.headerSpriteL.position.set(window.innerWidth * 0.5, this.headerSpriteL.height);
      this.goalsL.position.set(window.innerWidth * 0.88, window.innerHeight * 0.6);
      config.header.reseize(this.goalsL, this.headerSpriteL);
      this.moves.style.fontSize = Math.round(window.innerHeight * 0.045);
      this.moves.y = this.headerSpriteL.y + this.headerSpriteL.height * 0.27;
      this.moves.x = this.headerSpriteL.x + this.headerSpriteL.width * 0.33;
      this.movesTextTitle.x = this.moves.x;
      this.movesTextTitle.y = this.headerSpriteL.y - this.headerSpriteL.height * 0.1;
      this.movesTextTitle.style.fontSize = Math.round(window.innerWidth * 0.02);
      if (this.movesMask) {
        this.movesMask.clear();
      }
      this.movesMask.beginFill(0xff00000, 0.4); //0.4
      this.movesMask.drawRect(this.moves.x - 30, this.moves.y - this.moves.height * 0.4, 64, 40);
      this.movesMask.endFill();
      this.scoreText.y = this.headerSpriteL.y + this.headerSpriteL.height * 0.27;
      this.scoreText.x = this.headerSpriteL.x - this.headerSpriteL.width * 0.02;
      this.scoreText.style.fontSize = Math.round(window.innerHeight * 0.05);
      this.HSText.x = this.scoreText.x;
      this.HSText.y = this.headerSpriteL.y - this.headerSpriteL.height * 0.1;
      this.HSText.style.fontSize = Math.round(window.innerWidth * 0.018);
      this.boosterMenu.x = 0;
      this.boosterMenu.y = 0;
      this.greenT.style.fontSize = Math.round(window.innerHeight * 0.027);
      this.blueT.style.fontSize = Math.round(window.innerHeight * 0.027);
      this.orangeT.style.fontSize = Math.round(window.innerHeight * 0.027);
      this.redT.style.fontSize = Math.round(window.innerHeight * 0.027);
      this.violetT.style.fontSize = Math.round(window.innerHeight * 0.027);
      this.multiT.style.fontSize = Math.round(window.innerHeight * 0.027);
      this.title.style.fontSize = Math.round(window.innerHeight * 0.045);
      this.title.position.set(window.innerWidth * 0.12, this.headerSpriteL.y);
      this.subTitle.style.fontSize = Math.round(window.innerHeight * 0.024);
      this.subTitle.position.set(window.innerWidth * 0.12, this.title.y + this.title.height * 0.5 + this.subTitle.height * 0.5);
      this.emotionText.position.set(window.innerWidth * 0.5, window.innerHeight * 0.6);
      this.boosterPopin.x = this.title.x;
      this.boosterPopin.y = this.title.y + this.title.height * 0.5;
      let coef = 375 / 0.1;
      this.pauseBt.scale.set(window.innerWidth / coef);
      this.pauseBt.position.set(window.innerWidth * 0.88, window.innerHeight * 0.1);
      this.GoalsTitle.x = this.goalsL.x;
      this.GoalsTitle.y = this.goalsL.y - this.goalsL.height * 0.425;
      this.GoalsTitle.style.fontSize = Math.round(window.innerWidth * 0.015);
    }
    this.reArrangeGoals();
  }
}
